var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandardDialog',{attrs:{"height":'90%'},on:{"click-outside":function($event){return _vm.$router.push({name: 'ProjectTaktPlan'})}},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('router-view')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }